import { ErrorBoundaryDialog } from "@Components/Base";
import { useAuthentication } from "@Hooks";
import { Router } from "@Router";
import {
  QueryClient,
  MutationCache,
  QueryCache,
  QueryClientProvider,
} from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useDialogs } from "@toolpad/core/useDialogs";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const QueryProvider = () => {
  const authentication = useAuthentication();
  const dialogs = useDialogs();
  const translation = useTranslation();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        // refetchInterval: false,
        // refetchIntervalInBackground: false,
        // refetchOnMount: false,
        // refetchOnReconnect: false,
        // retryOnMount: false,
      },
    },
    mutationCache: new MutationCache({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (error: any) => dialogs.open(ErrorBoundaryDialog, error),
      onMutate: (_, mutation) => {
        if (!mutation.meta?.IGNORE_BASE_TOASTER)
          toast.promise(
            mutation.continue(),
            {
              loading: "Yükleniyor",
              error: null,
              success: "İşlem Başarılı",
            },
            {
              error: {
                style: {
                  display: "none",
                },
              },
            }
          );
      },
    }),
    queryCache: new QueryCache({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (error: any) => dialogs.open(ErrorBoundaryDialog, error),
    }),
  });

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider
        router={Router}
        context={{
          authentication,
          queryClient,
          translation,
        }}
      />
    </QueryClientProvider>
  );
};

export default QueryProvider;
